<div *ngIf="cargando">
  <div class="text-center py-5">
    <mat-spinner class="img-center"></mat-spinner>
  </div>
  <div class="text-center py-5">
    <span>Cargando datos...</span>
  </div>
</div>

<!-- ====================== búsqueda de horarios ====================== -->
<div class="row mx-2 mt-3" *ngIf="!cargando">
  <!-- ====================== input búsqueda ====================== -->
  <div class="col-12 col-xl-6 d-flex gap-2" *ngIf="!isModificando">
    <div class="col-6 text-start">
      <label class="mb-0 text-start">Buscar horario</label>
      <ng-select [items]="horariosFiltrados" [(ngModel)]="inputBuscarHorario" bindLabel="nombreHorario" (ngModelChange)="buscarHorario($event)" (clear)="limpiarBusqueda()" notFoundText="Horario no encontrado" placeholder="Buscar horario" appendTo="body" dropdownPosition="auto">
        <ng-template ng-option-tmp let-item="item">
          {{ item.nombreHorario }}
        </ng-template>
      </ng-select>
    </div>
    <div class="col-6 text-start">
      <label class="form-label mb-0">Ordenar horarios</label>
      <ng-select [searchable]="false" [clearable]="false" [items]="opcionesFiltros | keyvalue" bindLabel="value" bindValue="key" [(ngModel)]="ordenarPor" (change)="aplicarFiltros()" placeholder="Selecciona una opción">
      </ng-select>
    </div>
  </div>
  <!-- ====================== botón agregar horario ====================== -->
  <div class="col-12 col-xl-6 d-flex justify-content-end gap-3 my-2 my-lg-0" *ngIf="!isModificando">
    <div class="form-check align-self-end" *ngIf="esDebugger">
      <input class="form-check-input" type="checkbox" id="mostrarTodosChk" [(ngModel)]="mostrarTodosHorarios" (change)="aplicarFiltros()">
      <label class="form-check-label fw-bold" for="mostrarTodosChk">Mostrar todos los horarios</label>
    </div>
    <div class="form-check align-self-end">
      <input class="form-check-input" type="checkbox" id="mostrarNocturnosCheck" [(ngModel)]="mostrarNocturnos" (change)="aplicarFiltros()">
      <label class="form-check-label fw-bold" for="mostrarNocturnosCheck">Mostrar solo nocturnos</label>
    </div>
    <div class="align-self-end">
      <button mat-raised-button matTooltip="Nuevo horario" class="text-success" (click)="agregarHorario()">
        <mat-icon class="me-0">more_time</mat-icon>
        <p class="ms-2 mb-0">Nuevo horario</p>
      </button>
    </div>
  </div>

  <div class="d-flex justify-content-end" *ngIf="isModificando">
    <button mat-raised-button matTooltip="Regresar" class="ms-3 text-danger" (click)="regresarHorarios()">
      <p class="mb-0">Regresar</p>
    </button>
  </div>

  <div class="alert alert-primary mt-4" *ngIf="!cargando && horariosFiltrados.length <= 0">
    <div>
      <strong>No hay horarios agregados</strong>
      <p>Aún no se ha registrado ningún horario en el sistema</p>
    </div>
  </div>

  <div class="row g-2 mt-0">
    <div *ngFor="let horario of horariosFiltrados" [ngClass]="{'col-12 col-lg-6': !isModificando, 'col-12': isModificando}">
      <app-horario-detalle [horario]="horario" [soloConsulta]="false" (recargarDatosEvent)="cargarDatosEvent($event)" (isModificandoEvent)="isModificandoEvent($event)" [horarioEmpleado]="false">
      </app-horario-detalle>
    </div>
  </div>
</div>
